import { ApiErrorPageWithTrans } from '@components/Error/ApiErrorPageWithTrans';
import { NoddiLoadingScreenWithTrans } from '@components/Loading/NoddiLoadingScreenWithTrans';
import { noddiAsync, URLKeys } from 'noddi-async';
import { useParams } from 'react-router-dom';
import { BookingUpdateOfferContent } from './BookingUpdateOfferContent';

export const BookingUpdateOffer = () => {
  const { slug } = useParams();

  const {
    data: booking,
    isPending: isBookingPending,
    error: bookingError
  } = noddiAsync.useGet({
    type: URLKeys.getBookingInfo,
    input: { slug: slug! }
  });

  if (isBookingPending) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (bookingError) {
    return <ApiErrorPageWithTrans error={[bookingError]} />;
  }

  return <BookingUpdateOfferContent booking={booking} />;
};
